const state = {
  sessionExpiredMainApp: false,
  loadingMainApp: false,
  widthWindowMainApp: 1500,
  heightWindowMainApp: null,
}

const getters = {
  isSessionExpiredMainApp: state => state.sessionExpiredMainApp,
  isLoadingMainApp: state => state.loadingMainApp,
  getWidthWindowMainApp: state => state.widthWindowMainApp,
  getHeightWindowMainApp: state => state.heightWindowMainApp,
}

const actions = {
  setSessionExpiredMainApp ({ commit }, newBool) {
    commit('SET_SESSION_EXP_MAIN_APP', newBool)
  },
  setLoadingMainApp ({ commit }, newBool) {
    commit('SET_LOADING_MAIN_APP', newBool)
  },
  setWidthWindowMainApp({ commit }, newFloat) {
    commit('SET_WIDTH_WINDOW_MAIN_APP', newFloat)
  },
  setHeightWindowMainApp({ commit }, newFloat) {
    commit('SET_HEIGHT_WINDOW_MAIN_APP', newFloat)
  },
}

const mutations = {
  SET_SESSION_EXP_MAIN_APP: (state, newBool) => (state.sessionExpiredMainApp = newBool),
  SET_LOADING_MAIN_APP: (state, newBool) => (state.loadingMainApp = newBool),
  SET_WIDTH_WINDOW_MAIN_APP: (state, newFloat) => (state.widthWindowMainApp = newFloat),
  SET_HEIGHT_WINDOW_MAIN_APP: (state, newFloat) => (state.heightWindowMainApp = newFloat),
}

export default {
  state,
  getters,
  actions,
  mutations
}